import createNodeWithContent from './createNodeWithContent';
import { ADDINS_CHANGE_SOURCE } from '../constants';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { ContentPosition, PositionType } from 'roosterjs-editor-types';

export default function updateContentToEditor(viewState: EditorViewState, content: string) {
    return lazyOperateContent.import().then(operateContent => {
        operateContent(viewState, (htmlEditor, originalRange, domUtils) => {
            if (htmlEditor.getContent(false /* triggerExtractContentEvent */) == content) {
                return null;
            }

            htmlEditor.setContent('');

            const contentNode = createNodeWithContent(content, htmlEditor.getDocument(), domUtils);
            htmlEditor.insertNode(contentNode, {
                position: ContentPosition.Begin,
                updateCursor: true,
                replaceSelection: false,
                insertOnNewLine: false,
            });

            return {
                selectionRange: contentNode
                    ? domUtils.createRange(contentNode, PositionType.After)
                    : null,
                changeSource: ADDINS_CHANGE_SOURCE,
            };
        });
    });
}
